import styled from 'styled-components';

export const StyledRow = styled.div`
    width: 940px;
    box-sizing: border-box;
    margin: 0 auto ${({ theme }) => theme.spacing * 3}px;;
    padding:  ${({ theme }) => theme.spacing}px
        ${({ theme }) => theme.spacing * 6}px;
    min-height: 44px;
    border-radius: 6px;
    display: grid;
    grid-template-columns: 50px 156px auto 90px 60px 30px;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
    > p {
        font-size: 14px;
        margin: 0;
        color: ${({ theme }) => theme.colors.blue};
        opacity: .87;
    }
    > .MuiButtonBase-root  {
        justify-self: end;
        opacity: 0;
        padding: ${({ theme }) => theme.spacing}px;
    }
    :hover {
        background-color: #062b5414;
        > .MuiButtonBase-root  {
            opacity: 1;
        }
    }
`
